/**
 * @fileoverview 错误信息展示页
 * @author hanzhichen <hanzhichen@baijiahulian.com>
 */

import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {LOGIN_ERROR_TYPE} from '~/constant/login';
import H5AccessError from './H5';
import WebAccessError from './Web';

/**
 * 获取要显示的图片信息
 * @param {string} errType 登录的错误类型
 * @param {boolean} isH5 是否移动端
 */
const getImgInfo = (errType, isH5) => {
    let imgSrc = '';
    let imgAlt = '';
    switch (errType) {
        case LOGIN_ERROR_TYPE.ACCESS_ERROR:
            imgSrc = isH5 ? '/assets/career__monochromatic.png' : '/assets/unauth.png';
            imgAlt = '未授权';
            break;
        case LOGIN_ERROR_TYPE.NETWORK_FORBIDDEN:
            imgSrc = isH5 ? '/assets/search_engine__monochromatic.png' : '/no-wifi.png';
            imgAlt = '拒绝访问';
            break;
        default:
            break;
    }
    return {imgSrc, imgAlt};
};

/**
 * 登录错误信息展示组件
 */
const AccessError = props => {
    const {location: {state: {type, title, msg} = {}}, agent: {isMobile}} = props;
    const {imgSrc, imgAlt} = getImgInfo(type, isMobile);
    return (
        isMobile
            ? <H5AccessError imgSrc={imgSrc} imgAlt={imgAlt} title={title} msg={msg} />
            : <WebAccessError imgSrc={imgSrc} imgAlt={imgAlt} title={title} msg={msg} />
    );
};

AccessError.propTypes = {
    location: PropTypes.shape({
        state: PropTypes.shape({
            type: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            msg: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    agent: PropTypes.shape({
        isMobile: PropTypes.bool.isRequired
    }).isRequired,
};

export default connect(({agent}) => ({agent}))(AccessError);
